import logo from '../../assets/images/brand/header_logo.png';

const COUNT = 24;

const MarqueeGroup = () => (
  <div className="marquee__group" aria-hidden="true">
    {Array.from({ length: COUNT }).map((_, index) => (
      <span className="marquee__item" key={index}>
        <img className="marquee__logo" src={logo} alt="" />
        <span className="marquee__sep" aria-hidden="true">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="marquee" aria-label="Banda Apps">
    <div className="marquee__track">
      <MarqueeGroup />
      <MarqueeGroup />
    </div>
  </div>
);
